module.exports = __webpack_public_path__ + "static/media/invite_user.25d369c7.svg";